import React from 'react';
import {
  CardInfo,
  CardInfoItem,
  CardInfoValueType,
  FlexItem,
  H3,
} from '@erecruit/ui-kit';
import { Intl } from '@erecruit/core';
import { Resources, AppPermissions } from '@erecruit/types';
import { Authorize } from '@erecruit/modules';

const { FormattedMessage } = Intl;

export default ({ data }: { data: Resources.Match }) => {
  const { facilityDepartments, positionType, worksite, generalComments } = data;

  return (
    <FlexItem>
      <CardInfo
        title={
          <H3 align="center">
            <FormattedMessage id={messageIds.vms.matchRecord.general.title} />
          </H3>
        }
      >
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.matchRecord.general.departments}
            />
          }
          type={CardInfoValueType.MultiSelect}
          value={
            facilityDepartments.length > 0
              ? facilityDepartments?.map(({ name }) => name)
              : '-'
          }
        />
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.matchRecord.general.positionType}
            />
          }
          type={CardInfoValueType.Text}
          value={positionType?.name}
        />
        <Authorize permission={AppPermissions.ViewPositionLocation}>
          <CardInfoItem
            label={
              <FormattedMessage
                id={messageIds.vms.matchRecord.general.worksite}
              />
            }
            type={CardInfoValueType.Text}
            value={worksite?.name}
          />
        </Authorize>
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.matchRecord.general.generalComments}
            />
          }
          type={CardInfoValueType.Text}
          value={generalComments}
        />
      </CardInfo>
    </FlexItem>
  );
};
